var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 20C1.98617 20 1.33683 19.7327 0.802 19.198C0.267333 18.6632 0 18.0138 0 17.25V14H3V0H18V17.25C18 18.0138 17.7327 18.6632 17.198 19.198C16.6632 19.7327 16.0138 20 15.25 20H2.75ZM15.2485 18.3333C15.555 18.3333 15.8124 18.2295 16.0208 18.022C16.2291 17.8143 16.3333 17.557 16.3333 17.25V1.66675H4.66675V14H14.1668V17.25C14.1668 17.557 14.2704 17.8143 14.4778 18.022C14.6851 18.2295 14.942 18.3333 15.2485 18.3333ZM6 6.33325V4.66675H15V6.33325H6ZM6 9.33325V7.66675H15V9.33325H6ZM2.73325 18.3333H12.5V15.6668H1.66675V17.25C1.66675 17.557 1.77092 17.8143 1.97925 18.022C2.18758 18.2295 2.43892 18.3333 2.73325 18.3333ZM2.73325 18.3333H1.66675H12.5H2.73325Z",
    fill: "#266128"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceActiveIcon);
export default __webpack_public_path__ + "static/media/invoice_active_icon.de7141e8de65dcb281d9187369b83cae.svg";
export { ForwardRef as ReactComponent };